import React, { useState } from "react";
import PropTypes from "prop-types";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Collapse, Stack } from "@mui/material";
import { withTranslation } from "react-i18next";

import CommentBox from "Components/Common/CommentBox";

import { useAdminCommentsByIdQuery } from "apis/ApplicationRequestComment";

const AdminDiscussion = ({
  adminCommentsQuery = {},
  t,
  isFireSafety,
  buildingInformationId,
   isUtilityTunnel = false,
}) => {
  const { data: { data: adminComments = [] } = {} } = useAdminCommentsByIdQuery(
    adminCommentsQuery,
    isFireSafety,
    buildingInformationId,
    isUtilityTunnel
  );

  const [openAdminDiscussion, setOpenAdminDiscussion] = useState(true);

  const handleDiscussionCollapse = () => {
    setOpenAdminDiscussion(!openAdminDiscussion);
  };
  return (
    <>
      {!!adminComments.length && (
        <>
          <div
            className="fs-4 fw-semibold mb-3 border-bottom"
            onClick={handleDiscussionCollapse}
          >
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>{t("Admin Comments")}</div>{" "}
              <p>{openAdminDiscussion ? <ExpandLess /> : <ExpandMore />}</p>
            </Stack>
          </div>
          <Collapse in={openAdminDiscussion} timeout="auto" unmountOnExit>
            {adminComments.map(({ comment, createdAt, name, role }, index) => (
              <CommentBox
                comment={comment}
                name={name}
                role={role}
                createdAt={createdAt}
                key={index}
              />
            ))}
          </Collapse>
        </>
      )}
    </>
  );
};

AdminDiscussion.propTypes = {
  adminCommentsQuery: PropTypes.object,
  isFireSafety: PropTypes.bool,
  buildingInformationId: PropTypes.number,
  t: PropTypes.func,
  isUtilityTunnel: PropTypes.bool,
};

export default withTranslation()(AdminDiscussion);
